import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import type { ReactNode } from 'react';

import { Layout } from './components/Layout';
import { StoreProvider } from './lib/store';
import { About } from './pages/About';
import { Catalog, NotFound } from './pages/Catalog';
import { CartPage } from './pages/CartPage';
import { Checkout } from './pages/Checkout';
import { OrderDone } from './pages/OrderDone';
import { ProductPage } from './pages/ProductPage';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('Не найден корневой элемент');

// Одни и те же страницы на трёх языках: английский в корне, русский под /ru,
// армянский под /hy. Язык из адреса разбирает StoreProvider
function pages(): ReactNode {
  return (
    <>
      <Route index element={<Catalog />} />
      <Route path="tea/:slug" element={<ProductPage />} />
      <Route path="about" element={<About />} />
      <Route path="cart" element={<CartPage />} />
      <Route path="checkout" element={<Checkout />} />
      <Route path="order/:number" element={<OrderDone />} />
      <Route path="*" element={<NotFound />} />
    </>
  );
}

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <StoreProvider>
        <Routes>
          <Route element={<Layout />}>
            {pages()}
            <Route path="ru">{pages()}</Route>
            <Route path="hy">{pages()}</Route>
          </Route>
        </Routes>
      </StoreProvider>
    </BrowserRouter>
  </StrictMode>,
);
